var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_close_big",
    "data-name": "icon / close big",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.8,
    height: 16.8,
    viewBox: "0 0 17.112 17.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M6.729,5.319H12.1V6.6H6.729v5.5H5.262V6.6H0V5.319H5.262V0H6.729Z",
    transform: "translate(8.556 0) rotate(45)",
    fill: "#727275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearText);
export default __webpack_public_path__ + "static/media/ClearText.a82d34800ff6fc8b928920018c914be2.svg";
export { ForwardRef as ReactComponent };